import { lazy } from 'react';

export const TestsAvailableBundle = lazy(
  () => import(/* webpackChunkName: "aware-tests-available" */ './tests-available-bundle')
);

export const TestCreationBundle = lazy(
  () =>
    import(
      /* webpackChunkName: "aware-test-creation" */ '@aware/pages/test-creation/test-creation'
    )
);

export const OnlineTestingBundle = lazy(
  () => import(/* webpackChunkName: "aware-online-test" */ './online-test-bundle')
);

export const TestEditorBundle = lazy(
  () => import(/* webpackChunkName: "aware-test-editor" */ './test-editor-bundle')
);

export const PostAssessmentBundle = lazy(
  () =>
    import(
      /* webpackChunkName: "aware-post-assessment" */ '@aware/pages/v2-post-assessment/pa-landing-page/pa-landing-page'
    )
);

export const StudentPortfoliosBundle = lazy(
  () =>
    import(/* webpackChunkName: "aware-student-portfolios" */ './student-portfolios-bundle')
);

export const AnswersBundle = lazy(
  () => import(/* webpackChunkName: "aware-answers" */ './answers-bundle')
);

export const ItemBankBundle = lazy(
  () => import(/* webpackChunkName: "aware-item-bank-bundle" */ './item-bank-bundle')
);

export const CustomItemBanksBundle = lazy(
  () =>
    import(
      /* webpackChunkName: "aware-custom-item-banks-bundle" */ '@aware/pages/custom-item-banks/index'
    )
);
